module.exports = __webpack_public_path__ + "img/matematica-interna.2e731465.png";